import { CHDevice } from "@app/project/model/ch-device";
import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { CommandHelper, EventHandlers } from "./command";
import { DcoCommand, DcoCommandData } from "./dco-command";

export interface DcoPropertyCommand extends DcoCommand {
    propertyName: string;
    propertyValue: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface DcoPropertyCommandData extends DcoCommandData {
    property_name: string;
    property_value: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class DcoPropertyCommandHelper extends CommandHelper {
    commandType = "DcoPropertyCommand";
    device: CHDevice;

    flyoutMenuActions = [];

    registerEventHandlers(handlers: EventHandlers) {
        this.flyoutMenuActions.length = 0;
        if (handlers.edit) {
            this.registerEditHandler(handlers.edit);
        }

        if (handlers.remove) {
            this.registerRemoveHandler(handlers.remove);
        }
    }

    registerEditHandler(emitter) {
        this.flyoutMenuActions.push({ name: $localize`:@@SHARED.BTN.EDIT:Edit`, action: emitter });
    }

    registerRemoveHandler(emitter) {
        this.flyoutMenuActions.push({ name: $localize`:@@SHARED.BTN.REMOVE:Remove`, action: emitter });
    }

    importMap: ImportMap<DcoPropertyCommand, DcoPropertyCommandData> = [
        { i: "name", o: "name" },
        { i: "command_id", o: "commandId" },
        { i: "command_type", o: "commandType" },
        { i: "uid", o: "deviceUid" },
        { i: "device_class", o: "deviceClass" },
        { i: "property_name", o: "propertyName" },
        { i: "property_value", o: "propertyValue" },
    ];
}
